{
  "name": "returns-angular",
  "version": "3.2.9",
  "buildNumber": "2026-09-10 | 3.2.9",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --configuration production --aot --output-hashing=all",
    "build-dev": "ng build --configuration development --aot --output-hashing=all",
    "watch": "ng build --watch --configuration development",
    "build-tag": "node build-tag.js",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.1.2",
    "@angular/cdk": "21.1.2",
    "@angular/common": "21.1.2",
    "@angular/compiler": "21.1.2",
    "@angular/core": "21.1.2",
    "@angular/forms": "21.1.2",
    "@angular/material": "21.1.2",
    "@angular/platform-browser": "21.1.2",
    "@angular/platform-browser-dynamic": "21.1.2",
    "@angular/router": "21.1.2",
    "@ngneat/elf": "2.3.2",
    "@ngx-translate/core": "15.0.0",
    "@ngx-translate/http-loader": "8.0.0",
    "@types/downloadjs": "^1.4.3",
    "bootstrap": "5.3.8",
    "classlist.js": "1.1.20150312",
    "downloadjs": "1.4.7",
    "html2canvas": "1.4.1",
    "jquery": "3.6.2",
    "jspdf": "^4.1.0",
    "pdf-lib": "1.17.1",
    "rxjs": "7.8.2",
    "tslib": "2.3.0",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular/build": "21.1.2",
    "@angular/cli": "21.1.2",
    "@angular/compiler-cli": "21.1.2",
    "@types/jasmine": "3.8.0",
    "@types/node": "12.20.24",
    "jasmine-core": "3.8.0",
    "karma": "6.4.0",
    "karma-chrome-launcher": "3.1.0",
    "karma-coverage": "2.0.3",
    "karma-jasmine": "4.0.0",
    "karma-jasmine-html-reporter": "1.7.0",
    "typescript": "5.9.3"
  }
}